module.exports = __webpack_public_path__ + "static/media/st-johns.bb577cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/st-johns.png
// module id = 42
// module chunks = 0